import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import './main.scss';
import posthog from 'posthog-js'
import { StrictMode, type FC } from 'react'
import { PostHogProvider } from '@posthog/react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { DatesProvider } from '@mantine/dates';
import { createTheme, MantineProvider } from '@mantine/core';
import { SkipToMainContent } from './components/skip-to-main-content';
import { LazyMotion, domMin } from 'framer-motion';
import { CookieConsent } from './components/cookie-consent';
import { routeConfig } from './router';

const theme = createTheme({});
const router = createBrowserRouter(routeConfig);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

if (import.meta.env.PROD && !window.location.host.includes('127.0.0.1') && !window.location.host.includes('localhost')) {
  // PostHog
  posthog.init(import.meta.env.VITE_POSTHOG_PUBLIC_API_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_API_HOST || 'https://eu.i.posthog.com',
    defaults: '2025-11-30',
    person_profiles: 'always',
    cookieless_mode: 'on_reject',
  });

  // Google Analytics
  {
    {
      const script = document.createElement('script');
      script.textContent = `// Define dataLayer and the gtag function.
window.dataLayer = window.dataLayer || [];
window.gtag = window.gtag || function() {dataLayer.push(arguments);}

// Set default consent to 'denied' as a placeholder
// Determine actual values based on your own requirements
window.gtag('consent', 'default', {
  'ad_storage': 'denied',
  'ad_user_data': 'denied',
  'ad_personalization': 'denied',
  'analytics_storage': 'denied'
});`;
      document.body.appendChild(script);
    }
    {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=${import.meta.env.VITE_GA_PROJECT_ID}`;
      script.async = true;
      document.body.appendChild(script);
    }
    {
      const script = document.createElement('script');
      script.textContent = `window.dataLayer = window.dataLayer || [];

  window.gtag('js', new Date());
  window.gtag('config', '${import.meta.env.VITE_GA_PUBLIC_KEY}');
  `;
      document.body.appendChild(script);
    }
  }

  {
    // Leadfeeder
    const script = document.createElement('script');
    script.textContent = `(function(ss,ex){ window.ldfdr=window.ldfdr||function(){(ldfdr._q=ldfdr._q||[]).push([].slice.call(arguments));}; (function(d,s){ fs=d.getElementsByTagName(s)[0]; function ce(src){ var cs=d.createElement(s); cs.src=src; cs.async=1; fs.parentNode.insertBefore(cs,fs); }; ce('https://sc.lfeeder.com/lftracker_v1_'+ss+(ex?'_'+ex:'')+'.js'); })(document,'script'); })('${import.meta.env.VITE_DEALFRONT_PROJECT_ID}');`;
    document.body.appendChild(script);
  }

  {
    // Ahrefs
    const script = document.createElement('script');
    script.src = 'https://analytics.ahrefs.com/analytics.js';
    script.setAttribute('data-key', 'pv4yVj7vYLJtU5G/ULbKeg');
    script.async = true;
    document.body.appendChild(script);
  }
}

// eslint-disable-next-line react-refresh/only-export-components
const App: FC = () => {
  return (
    <StrictMode>
      <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_PUBLIC_API_KEY}>
        <SkipToMainContent />
        <QueryClientProvider client={queryClient}>
          <MantineProvider theme={theme}>
            <DatesProvider settings={{ locale: 'en-uk' }}>
              <LazyMotion features={domMin} strict>
                <RouterProvider router={router} />
                <CookieConsent />
              </LazyMotion>
            </DatesProvider>
          </MantineProvider>
        </QueryClientProvider>
      </PostHogProvider>
    </StrictMode>
  );
};

createRoot(document.getElementById('root')!).render(<App />)
